export * from './information-dialog.component';
